// @ts-ignore
import bops from 'bops'

/**
 * this function encodes a guid to a 22 character base64 encoded string as described at
 * https://www.meziantou.net/reducing-the-string-length-of-guids-in-urls.htm
 * @param {string} guid - the guid to convert
 * @return {string} a 22 character encoded version of the guid
 */
export function encodeGuid(guid: string): string {
  const hex = bops.from(guid.replace(/-/g, ''), 'hex')
  const newHex = new Uint8Array(hex)
  // due to byte-endian differences on server vs this bops implementation
  newHex[0] = hex[3]
  newHex[1] = hex[2]
  newHex[2] = hex[1]
  newHex[3] = hex[0]
  newHex[4] = hex[5]
  newHex[5] = hex[4]
  newHex[6] = hex[7]
  newHex[7] = hex[6]
  const b64 = bops.to(newHex, 'base64')
  return b64.substr(0, 22)
}

/**
 * this function encodes an array of guids to a single string containing 22 character encoded forms of each
 * guid.  An array of 3 guids should yield a string with 66 characters, for example.
 * @param {Array<string>} guids - the guids to convert
 * @return {string} a string containing all the encoded guids, concatenated together
 */
export function encodeGuidsToString(guids: Array<string>): string {
  if (!guids.length) {
    return ''
  }
  const encodedGuids = guids.map(guid => encodeGuid(guid))
  const json = JSON.stringify(encodedGuids).replace(/","/g, '')
  return json.substring(2, json.length - 2)
}
